import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        minHeight: 0,
        minWidth: 0,
        flex: 1,
        ...webStyle({
            overscrollBehavior: "contain",
            scrollbarGutter: "stable"
        })
    },
    content: {
        flexDirection: "column",
        flexGrow: 1
    }
});
export default stylesheet;
